import * as React from "react";

// style, design
import * as SharedStyles from "../../../components/sharedStyles";

// store, state

import {
  OverviewTitle,
  OverviewTitleWrapper,
} from "../../../components/Details/OverviewInfo/styles";
import { PrimaryButton } from "../../../components/Forms/Base/Buttons";
import { useParams } from "react-router";
import { useDispatch, useSelector } from "react-redux";
import { getFortnoxSettings } from "../../../store/billectaIntegrations";
import { uid } from "uid";
import { InfoBox } from "../../../components/Displays";
import { useFortnoxForm } from "../../../store/billectaIntegrations/hooks/form";
import { constants } from "../../../store/billectaIntegrations";
import { DatePicker, TextInput } from "../../../components/Forms/Base/Fields";
import moment from "moment";
import { useBrfCompany } from "../../../store/brfCompanies";

export default function BrfCompanyActivateFortnox() {
  const dispatch = useDispatch();
  const { brfCompanyId } = useParams();
  const returnUrl = `https://${window.location.hostname}/configcenter/integrations/activate-fortnox-complete/brf/${brfCompanyId}`;

  const [brfCompany] = useBrfCompany(brfCompanyId);
  const company = brfCompany?.company;
  const creditorId = company?.billecta_id;

  const fortnoxSettings = useSelector(
    (state) => state.billectaIntegrations.fortnoxSettings
  );

  const instance = useSelector(
    (state) => state[constants.STORE_NAME].formInstance
  );

  useFortnoxForm("PUT", true);

  React.useEffect(() => {
    if (!fortnoxSettings) dispatch(getFortnoxSettings(creditorId));
  }, [creditorId]);

  const goToActivationPage = () => {
    const state = uid();
    const voucherSeries = instance?.VoucherSeries;
    const startDate = instance?.StartDate;

    localStorage.setItem("fnx_state", state);
    localStorage.setItem("fnx_voucher_series", voucherSeries);
    localStorage.setItem("fnx_start_date", startDate);
    localStorage.setItem("fnx_redirect_uri", returnUrl);

    window.location.href = `https://apps.fortnox.se/oauth-v1/auth?client_id=32hsGLkR78Av&scope=settings%20project%20price%20bookkeeping%20costcenter&state=${state}&access_type=offline&response_type=code&redirect_uri=${returnUrl}`;
  };

  return (
    <SharedStyles.DetailInnerWrapper>
      <SharedStyles.DetailPageBox>
        <OverviewTitleWrapper>
          <OverviewTitle>Aktivera Fortnox-integration</OverviewTitle>
        </OverviewTitleWrapper>

        <SharedStyles.InnerBox>
          {!!fortnoxSettings?.APICode && (
            <InfoBox
              boxTheme="warning"
              title="Redan aktiverad"
              text="Denna integration är redan aktiverad för detta bolag"
            />
          )}

          <SharedStyles.BodyText style={{ marginBottom: 12 }}>
            Aktivering att integrationen Fortnox sker genom att autentisera mot
            Fortnox via deras inloggningssida. Tryck på knappen för att
            autentisera och aktivera integrationen. När du autentiserat kommer
            du att skickas tillbaka till Pigello.
          </SharedStyles.BodyText>

          <DatePicker
            title="Startdatum för verifikationsserie"
            storeName={constants.STORE_NAME}
            fieldKey={"StartDate"}
            forceRequired
            method={"PUT"}
            minDate={moment().set({ year: "2010", month: 0, day: 1 }).toDate()}
          />

          <TextInput
            storeName={constants.STORE_NAME}
            fieldKey={"VoucherSeries"}
            method={"PUT"}
          />

          <div style={{ marginTop: 12 }}>
            <PrimaryButton
              title="Autentisera och aktivera Fortnox-integration"
              clicked={goToActivationPage}
              disabled={
                !!fortnoxSettings?.APICode ||
                !instance?.VoucherSeries ||
                !instance?.StartDate
              }
            />
          </div>
        </SharedStyles.InnerBox>
      </SharedStyles.DetailPageBox>
    </SharedStyles.DetailInnerWrapper>
  );
}
